export default __webpack_public_path__ + "static/media/jade.749d57b8.svg";